import ApplicationSerializer from "./application";

export default class LoadBalancerTargetSerializer extends ApplicationSerializer {
  attrs = {
    active: {
      serialize: false,
    },
    status: {
      serialize: false,
    },
    listener: {
      serialize: false,
    },
  };

  normalize(modelClass, resourceHash, prop) {
    resourceHash.active = resourceHash.status === "MAINT" ? "no" : "yes";
    return super.normalize(modelClass, resourceHash, prop);
  }
}
